import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '../../store/hooks';
import { selectAuthSession } from '../store/selectors';

const useLayoutVM = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  useEffect(
    function scrollToTop() {
      ref.current?.scrollTo(0, 0);
    },
    [pathname]
  );

  const session = useAppSelector((state) => selectAuthSession(state));

  return { ref, session };
};

export default useLayoutVM;
